import type { ISampleCampaign, ISampleProjectDetail } from '../sampleData';

type TStatus = ISampleCampaign['status'] | ISampleProjectDetail['status'];

/*
 * Single status → pill-theme map shared by Projects and Campaigns. Maps both
 * status namespaces onto a small semantic palette so a tester scanning a mixed
 * list never has to translate (e.g.) cyan-means-different-things.
 */
const STATUS_THEME: Record<TStatus, string> = {
  draft: 'neutral',
  planning: 'neutral',
  live: 'green',
  active: 'green',
  paused: 'yellow',
  sent: 'sky',
  completed: 'sky',
};

const STATUS_LABEL: Record<TStatus, string> = {
  draft: 'Draft',
  planning: 'Planning',
  live: 'Live',
  active: 'Active',
  paused: 'Paused',
  sent: 'Sent',
  completed: 'Completed',
};

export function statusTheme(status: TStatus): string {
  return STATUS_THEME[status];
}

export function statusLabel(status: TStatus): string {
  return STATUS_LABEL[status];
}
